const definitionStrategies = {
  DEFAULT: 0,
  PNG: 1, // TODO Rename it appropriately
  HACH: 2,
};

module.exports = definitionStrategies;
